/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Text, View } from 'react-native';
import { ticketControls } from './ticketControls.styles';

type Props = {
  label: string;
  children: React.ReactNode;
  hint?: string;
  warn?: string;
};

export function TicketField({ label, children, hint, warn }: Props) {
  return (
    <View style={ticketControls.field}>
      <Text style={ticketControls.fieldLabel}>{label}</Text>
      {children}
      {warn ? <Text style={ticketControls.warn}>{warn}</Text> : null}
      {!warn && hint ? <Text style={ticketControls.hint}>{hint}</Text> : null}
    </View>
  );
}
